<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Map" class="d-icon d-icon--map" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M10.763 1.075A.5.5 0 0 1 11 1.5V9a.5.5 0 0 1-.276.447l-3 1.5a.5.5 0 0 1-.448 0L4.5 9.56l-2.776 1.388A.5.5 0 0 1 1 10.5V3a.5.5 0 0 1 .276-.447l3-1.5a.5.5 0 0 1 .448 0L7.5 2.44l2.776-1.388a.5.5 0 0 1 .487.022ZM7 3.309l-2-1v6.382l2 1V3.309Zm1 6.382 2-1V2.309l-2 1v6.382Zm-4-1V2.309l-2 1v6.382l2-1Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconMap',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
